import { FilterFieldDef } from '../components/molecules/FilterBar/AddFilterModal.types';

/**
 * Restrict a list-page filter catalog to fields the user currently sees as
 * columns. Used to lock client/customer users into filtering by the data the
 * curated saved-report exposes — they should never be able to filter by a
 * hidden column.
 *
 * Returns a new array preserving the input order. An empty `visibleFields`
 * yields an empty list (the locked-down "nothing to filter by" extreme).
 */
export const filterFieldDefinitionsByVisibleColumns = (
  allDefs: ReadonlyArray<FilterFieldDef>,
  visibleFields: ReadonlyArray<string>
): FilterFieldDef[] => {
  const allowed = new Set(visibleFields);
  return allDefs.filter((def) => allowed.has(def.key));
};

/**
 * Whether a field key is in the visible-columns allowlist. Used as the
 * defense-in-depth sort guard — even if the table head somehow exposes a
 * hidden-column header (saved-report restore, future refactor, etc.) the page
 * handler refuses to sort by a field the user shouldn't see.
 */
export const isFieldVisible = (field: string, visibleFields: ReadonlyArray<string>): boolean =>
  visibleFields.includes(field);
